import axios from "axios"

import {apiError, apiSuccessMessage, throwFieldsError} from "./utils-actions"

import {AUTH_USER, FETCH_USER} from "./types";
import {API_URL} from "../config/environment-variables";
import {ROLE_APP_USER} from "../utils/roles";
import {ONBOARDING_THANK_YOU_URL} from "../utils/redirect-const";

const ENDPOINT_URL = `${API_URL}/onboarding`;

export function loginUserFromResponse(dispatch, response) {
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('role', response.data.role);

    dispatch({
        type: AUTH_USER,
        payload: response.data.role
    });
}

export function registerAppUser(values, form, navigate) {
    return dispatch => axios.post(`${ENDPOINT_URL}/register`, values)
        .then(() => navigate(ONBOARDING_THANK_YOU_URL, { state: { role: ROLE_APP_USER } }))
        .catch(error => {
            form.setSubmitting(false);
            throwFieldsError(error.response.data, form.setErrors, form.setStatus);
            dispatch(apiError('Unable to register.', error));
        });
}

export function activateUser(confirmationId, values) {
    return dispatch => {
        axios.post(`${ENDPOINT_URL}/confirmation`, {...values, confirmationId: confirmationId})
            .then((response) => {
                loginUserFromResponse(dispatch, response)
                dispatch(apiSuccessMessage(`Account verified successfully`))
            })
            .catch(error => dispatch(apiError('Unable to activate user.', error)));
    }
}

export function fetchUserByConfirmationId(confirmationId, actionId) {
    return dispatch => {
        axios.get(`${ENDPOINT_URL}/profile/${confirmationId}`)
            .then(response => {
                dispatch({
                    type: FETCH_USER,
                    payload: response.data
                });
                dispatch(apiSuccessMessage(null, actionId));
            })
            .catch(response => {
                dispatch(apiError(null, response, actionId));
            });
    }
}

